import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["mode", "children"];
import { AVAILABLE_THEMES } from "@vitality-ds/system";
import React from "react";
import { ThemeProvider } from "../../ThemeProvider";
import { jsx as _jsx } from "react/jsx-runtime";
function ColorModeProvider(_ref) {
  var mode = _ref.mode,
    children = _ref.children,
    restProps = _objectWithoutProperties(_ref, _excluded);
  /**
   * The string returned from Stitches and createTheme() is the className which maps to the relevant CSS variables of that theme
   */
  var colorModeClassName = AVAILABLE_THEMES[mode];
  return /*#__PURE__*/_jsx(ThemeProvider, _extends({}, restProps, {
    children: /*#__PURE__*/_jsx("div", {
      className: colorModeClassName,
      children: children
    })
  }));
}
export default ColorModeProvider;